import script from "./FormAutoComplete.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormAutoComplete.vue?vue&type=script&setup=true&lang=ts"

import "./FormAutoComplete.vue?vue&type=style&index=0&id=3c36f014&lang=scss"

const __exports__ = script;

export default __exports__